import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading, null = anon

    useEffect(() => {
        const token = localStorage.getItem("ferahis_token");
        if (!token) {
            setUser(null);
            return;
        }
        api
            .get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(null));
    }, []);

    async function login(email, password) {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("ferahis_token", data.token);
        setUser(data.user);
        return data.user;
    }

    function logout() {
        localStorage.removeItem("ferahis_token");
        setUser(null);
        window.location.href = "/giris";
    }

    return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
    return useContext(AuthContext);
}
